import styles from "./landing-page-mobile-one.module.css";
import { HeroSectionMobile } from "./sections/hero-section-mobile";
import { TaglineSectionMobile } from "./sections/tagline-section-mobile";
import { ProductSectionMobile } from "./sections/product-section-mobile";
import { GiftSectionMobile } from "./sections/gift-section-mobile";
import { ShippingSectionMobile } from "./sections/shipping-section-mobile";
import { PresetsSectionMobile } from "./sections/presets-section-mobile";
import { CTASectionMobile } from "./sections/cta-section-mobile";
import { FooterSectionMobile } from "./sections/footer-section-mobile";
import { usePaths } from "BEDROCK/paths";

export const LandingPageMobileOne = () => {
  const paths = usePaths();

  const startDesigning = () => {
    paths.navigateTo(paths.collectionList + "/A");
  };

  return (
    <div className={styles.parallaxContainer}>
      <div className={styles.backgroundContainer}></div>
      <div className={styles.foregroundContainer}>
        <HeroSectionMobile onClickStart={startDesigning} />
        <TaglineSectionMobile />
        <ProductSectionMobile onClick={startDesigning} />
        <GiftSectionMobile onClick={startDesigning} />
        <ShippingSectionMobile />
        <PresetsSectionMobile onClickTemplate={startDesigning} />
        <CTASectionMobile onClickCTA={startDesigning} />
        <FooterSectionMobile />
      </div>
    </div>
  );
};
